import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from './styles';

const ICONS = {
  assignment: '📲',
  plane: '🛬',
  message: '💬',
  default: '🔔',
};

function NotificationBanner({ notification, onDismiss, onAction }) {
  useEffect(() => {
    if (!notification) return;
    const t = setTimeout(() => onDismiss(), 5000);
    return () => clearTimeout(t);
  }, [notification, onDismiss]);

  if (!notification) return null;

  const icon = ICONS[notification.type] || ICONS.default;

  const handleClick = () => {
    if (onAction) onAction(notification);
    onDismiss();
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: 'absolute',
        top: 4,
        left: 4,
        right: 4,
        zIndex: 100,
        backgroundColor: 'rgba(15, 23, 42, 0.97)',
        border: `1px solid ${COLORS.accent}`,
        borderRadius: 2,
        p: 1.25,
        boxShadow: `0 4px 18px rgba(34, 211, 238, 0.4)`,
        cursor: 'pointer',
        animation: 'slideIn 250ms ease-out',
        '@keyframes slideIn': {
          from: { transform: 'translateY(-110%)', opacity: 0 },
          to:   { transform: 'translateY(0)',     opacity: 1 },
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Typography sx={{ fontSize: '1.1rem', lineHeight: 1 }}>{icon}</Typography>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: '0.65rem', color: COLORS.accent, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6 }}>
            {notification.title}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: COLORS.textPrimary, mt: 0.25, lineHeight: 1.3 }}>
            {notification.body}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default NotificationBanner;
